import React, { ReactElement, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box } from '@material-ui/core';

import { BreadcrumbItem } from '..';
import {
	Breadcrumb,
	PageType,
	AppState,
	AppThunkDispatch,
	IndexAction,
	indexClearHistory
} from '../../../redux';
import { storeBreadcrumbs } from '../../../utils';

import './index-history.styles.scss';

export interface IIndexHistoryStateProps {
	history: Breadcrumb[];
	clearHistory: () => void;
}

export interface IIndexHistoryOwnProps {
	returnTo: (page: Breadcrumb) => void;
}

function IndexHistoryView(
	props: IIndexHistoryStateProps & IIndexHistoryOwnProps
): ReactElement {
	const { history, clearHistory, returnTo } = props;

	useEffect(() => {
		return () => clearHistory();
	}, []);

	useEffect(() => {
		if (history && history.length > 0) storeBreadcrumbs(history);
	}, [history]);

	const indexPage: Breadcrumb = {
		type: PageType.Index,
		name: 'Index',
		id: ' '
	};

	return (
		<Box className="index-page-breadcrumb">
			<Box
				className="index-page-breadcrumb-history"
				data-mdat="referrer"
				data-mdat-module="index-breadcrumbs"
			>
				{history.length > 0 && (
					<BreadcrumbItem page={indexPage} returnTo={returnTo} />
				)}
				{history.map((page: Breadcrumb) => (
					<BreadcrumbItem
						key={page.id}
						page={page}
						returnTo={returnTo}
					/>
				))}
			</Box>
		</Box>
	);
}

function mapStateToProps(state: AppState) {
	return {
		history: state.index.history
	};
}

function mapDispatchToProps(dispatch: AppThunkDispatch<IndexAction>) {
	return {
		clearHistory: () => dispatch(indexClearHistory())
	};
}

export const IndexHistory = connect(
	mapStateToProps,
	mapDispatchToProps
)(IndexHistoryView);
